<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.promotion.support' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__checkbox" aria-invalid="false">
          <legend class="p-support-info__checkbox-legend" [innerHTML]="'label.promotion.support' | staticMsg"></legend>
          <div class="p-support-info__checkbox-list">
            <!-- [14.3] 歩行障がい -->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="checkbox1_1"
                class="p-support-info__checkbox-item-input"
                [disabled]="isDisableDegreeOfWaling"
                [(ngModel)]="degreeOfWalking"
              />
              <label for="checkbox1_1" class="p-support-info__checkbox-item-label">
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span
                    class="p-support-info__checkbox-item-text"
                    [innerHTML]="'label.degreeOfWalking' | staticMsg"
                  ></span>
                </span>
              </label>
            </div>
            <!-- [14.4] 視覚障がい -->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="checkbox1_2"
                class="p-support-info__checkbox-item-input"
                [(ngModel)]="blind"
              />
              <label for="checkbox1_2" class="p-support-info__checkbox-item-label">
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span class="p-support-info__checkbox-item-text" [innerHTML]="'label.blind' | staticMsg"></span>
                </span>
              </label>
            </div>
            <!-- [14.5] 聴覚障がい -->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="checkbox1_3"
                class="p-support-info__checkbox-item-input"
                [(ngModel)]="deaf"
              />
              <label for="checkbox1_3" class="p-support-info__checkbox-item-label">
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span class="p-support-info__checkbox-item-text" [innerHTML]="'label.deaf' | staticMsg"></span>
                </span>
              </label>
            </div>
            <!-- [14.6] 妊婦中 -->
            <div class="p-support-info__checkbox-item">
              <input
                type="checkbox"
                name="checkbox1"
                id="checkbox1_4"
                class="p-support-info__checkbox-item-input"
                [(ngModel)]="pregnant"
              />
              <label for="checkbox1_4" class="p-support-info__checkbox-item-label">
                <span class="p-support-info__checkbox-item-check"></span>
                <span class="p-support-info__checkbox-item-text-wrap">
                  <span class="p-support-info__checkbox-item-text" [innerHTML]="'label.pregnant' | staticMsg"></span>
                  <span
                    class="p-support-info__checkbox-item-guidance"
                    [innerHTML]="'label.detailofpregnant' | staticMsg"
                  ></span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
